$(function() {

    console.log("first_request", first_request);
    console.log("request_host", request_host);
    
    if(request_host.includes('durpets.com') && request_path !== '/pages/dur' && first_request == ""){
      console.log("durpets.com");

      let attributes = {
        attributes: {
          first_request: "true"
        }
      };

      console.log("redirect");
      //location.href = '/pages/dur';

      
      updateCartAttribute(attributes, function(data){
        console.log(data);
        //location.href = '/pages/home-naval';
        location.href = '/pages/dur';
      });
      
    }

    $(document).on('click', '.remove_all_items', function(){
        $("body").addClass("loading");
        $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            dataType: 'json',
            success: function(cart) {
                $("body").removeClass("loading");
                location.reload();
            }
        });
    });

    ipLookUp(function(location){
		  console.log("ip_location");
		  console.log(location); 
        
       	  if(location != "CO"){
            if(cart_location == null || cart_location == ""){

              let attributes = {
                 attributes: {
                  'location': location
                }
              };
              
              updateCartAttribute(attributes, function(response){
              	window.location.reload();
              });
            }
            else {
          		//$(elements_to_hide).hide();
              	console.log("a iter");
            }
          } else {
            let attributes = {
                 attributes: {
                  'location': 'CO'
                }
            };
            
          	updateCartAttribute(attributes, function(response){
            });
          }
      });	


});

function ipLookUp (callback) {
  if(sessionStorage.getItem('location_id'))
  {
  	  callback(sessionStorage.getItem('location_id'));
  }
  else
  {  
      //$.ajax('https://ip-api.com/json/?fields=61439')
      $.ajax('https://ipapi.co/json/')
      .then(
          function success(response) {
              //console.log('User\'s Location Data is ', response);
              //console.log('User\'s Country', response.country);
              sessionStorage.setItem('location_id', response.country); 	
              callback(response.country);
          },

          function fail(data, status) {
              console.log('Request failed.  Returned status of',
                          status);
          }
      );
  }
}

function updateCartAttribute(params, callback){
   //fetch update.js
    fetch('/cart/update.js', {
     method: 'POST',
     headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
     },
     body: JSON.stringify(params)
    }).then(response => response.json())
    .then(data => {
        console.log("update.js");
        console.log(data);
        callback(data);
    });
}


